import { render, staticRenderFns } from "./EmbedView.vue?vue&type=template&id=ec9480e2&"
import script from "./EmbedView.vue?vue&type=script&lang=js&"
export * from "./EmbedView.vue?vue&type=script&lang=js&"
import style0 from "./EmbedView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports